import type { IconSvgObject } from './types';

const ChevronRightIcon: IconSvgObject = [
  ["path", { d: "M9.00005 18C9.00005 18 15 13.5811 15 12C15 10.4188 9 6 9 6", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }]
];

export default ChevronRightIcon;
